import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Developing Web Applications and Microservices',
                topics: [
                    'Building web applications with Go and the Gin framework',
                    'Building RESTful APIs with Go and the Gorilla toolkit',
                    'Developing microservices with Go and gRPC',
                    'Developing scalable and secure cloud-native applications with Go and Kubernetes',
                    'Building scalable web services with Go and Cassandra',
                    'Building distributed systems with Go and Apache Kafka',
                ],
            },
            {
                title: 'Concurrency, Testing, and Optimization',
                topics: [
                    'Leveraging Go channels for concurrent programming',
                    'Best practices for testing Go applications',
                    'Practical design patterns for Go developers',
                    'Exploring the latest features in Go 1.20',
                    'Debugging and profiling Go applications: tips and tricks',
                    'Implementing authentication and authorization in Go applications',
                ],
            },
            {
                title: 'Developing Blockchain, Desktop Apps, and System Architecture',
                topics: [
                    'Developing chatbots and conversational interfaces with Go',
                    'Developing blockchain applications with Go',
                    'Building cross-platform desktop apps with Go and Electron',
                    'Building scalable and fault-tolerant systems with Go',
                    'Concurrency in Go: a deep dive',
                    'Building command-line tools with Go',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What is the event about?</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;